import HttpRequest from './http_request'

class payInSlipProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL)
  }

  //-------------------------------------------------------------สำหรับสมัคร 
  //ข้อมูลการสมัคร
  async getPaymentApplicationFee(REGISTER_ID, uid = null) {
    const { data } = await this.get('/', {
      function: 'get-payment-application-fee',
      REGISTER_ID: REGISTER_ID,
      UID: uid,
    })
    return data
  }

  async getPaymentAssertionFee(REGISTER_ID, uid = null) {
    const { data } = await this.get('/', {
      function: 'get-payment-confirm-fee',
      REGISTER_ID: REGISTER_ID,
      UID: uid,
    })
    return data
  }

  async saveAssertionFee({ REGISTER_ID, PAYMENT_CONFIRM_FEE }) {
    const { data } = await this.update('/', {
      function: 'set-assertion-fee',
      REGISTER_ID: REGISTER_ID,
      PAYMENT_CONFIRM_FEE: PAYMENT_CONFIRM_FEE,
    })
    return data
  }

  async saveCurriculumAndApplicantStatus({ REGISTER_ID, REGISTER_STATUS_ID, REFUSED, register_curriculum }) {
    const { data } = await this.update('/', {
      function: 'set-curriculum-and-applicant-status',
      REGISTER_ID: REGISTER_ID,
      REGISTER_STATUS_ID: REGISTER_STATUS_ID,
      REFUSED: REFUSED,
      register_curriculum: register_curriculum,
    })
    return data
  }

}

export default payInSlipProvider